export const palette = {
  alternate: {
    main: '#F9F6FF',
    light: '#F9F8F8',
    dark: '#E5EAF4',
  },
  chart: {
    unused: '#C0DCE8',
  },
  cardShadow: 'rgba(23, 70, 161, .11)',
  type: 'light',
  primary: {
    main: '#BE9A47', // Color changes from main palette
    contrastText: '#FFF',
    light: '#f9e1cf',
  },
  secondary: {
    main: '#BE9A47', // Color changes from main palette
    contrastText: '#FFFFFF', // Color changes from main palette
  },
  text: {
    primary: '#231942',
    secondary: '#5A6D8E',
    disabled: '#CCC',
    highlight: '#FFF',
    success: '#1CA179',
    border: '#E5EAF4',
    terms: '#BE9A47', // Added property (not in main palette)
    promotion: '#00786F',
  },
  divider: 'rgba(0, 0, 0, 0.12)',
  background: {
    main: '#FFFFFF', // Color changes from main palette
    paper: '#FFF',
    light: '#EDE9FF',
    default: '#FFF',
    footer: '#002855',
    level2: '#f7f8fb', // Color changes from main palette
    level1: '#FFF',
    tableHead: '#DDDDDD',
    tableSubhead: '#4d236c1a',
    tableAlternate: '#F8F8F8',
    alternate: '#E3F1FD',
    success: '#DBEFDC',
    error: '#FFEAEA',
    secondary: '#F8D859',
    promotion: '#DDFFF8',
    serviceIcon: '#F8FAFC',
  },
  verticalBar: {
    used: '#E56B10',
    unused: '#f9e1cf',
    unlimited: '#C0C0C0',
  },
};
